import React from "react";
import { Box, Button, Typography } from "@mui/material";

import HowToSellImage from "../../../images/resources/sellwidleon.png";
import { GetURL } from "../../../config";
import { PageContainer } from "../../../components/gallery/Section";
import ArtworkFrame from "../../../components/gallery/ArtworkFrame";
import { tokens } from "../../../theme/galleryTheme";

const HOW_TO_SELL_PATH = "/how-to-sell";


async function registerHowToSellMeta() {
  const pageUrl = `${GetURL}${HOW_TO_SELL_PATH}`;

  try {
    await fetch(`${GetURL}/meta`, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({
        title: "How to Sell Art at Leon Gallery",
        discription:
          "Discover the step-by-step process of consigning your artwork to Leon Gallery.",
        lotNo: "",
        canonical: pageUrl,
        url: pageUrl,
        imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
      }),
    });
  } catch (error) {
    console.error("Failed to register page meta:", error);
  }
}

function HowTosell() {
  // Unchanged behaviour: register meta, then go to /how-to-sell.
  const handleClick = async (event) => {
    event.preventDefault();
    await registerHowToSellMeta();
    window.location.href = HOW_TO_SELL_PATH;
  };

  return (
    <Box
      component="section"
      aria-labelledby="home-sell-title"
      sx={{ bgcolor: tokens.color.ivory, py: tokens.layout.sectionY }}
    >
      <PageContainer>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1fr) minmax(0, 1fr)" },
            gap: { xs: 4, md: 8 },
            alignItems: "center",
          }}
        >
          
          <ArtworkFrame
            src={HowToSellImage}
            alt="Artwork being prepared for consignment at León Gallery"
            ratio="4 / 3"
            fit="contain"
            padding={0}
            mat={tokens.color.paper}
          />

          <Box sx={{ display: "grid", gap: 2.5, justifyItems: "start" }}>
            <Typography variant="overline" component="p">
              Consignment
            </Typography>
            <Typography id="home-sell-title" variant="h2" component="h2">
              Sell with León Gallery
            </Typography>
            <Typography variant="body1" sx={{ maxWidth: "48ch" }}>
              Join the Philippines&apos; premier auction house. Our specialists provide
              world-class expertise and bespoke marketing to ensure your artworks reach
              their highest potential.
            </Typography>
            <Button
              variant="contained"
              size="large"
              href={HOW_TO_SELL_PATH}
              onClick={handleClick}
              sx={{ mt: 1, width: { xs: "100%", sm: "auto" }, px: 5 }}
            >
              Request an estimate
            </Button>
          </Box>
        </Box>
      </PageContainer>
    </Box>
  );
}

export default React.memo(HowTosell);
